import { memo } from 'react';

import { FileStatus } from '../../constants/FileStatus';
import { type FileStatusIconSize } from '../fileStatusIconSize';
import { FileStatusIconCompleted } from './FileStatusIconCompleted';
import { FileStatusIconErrored } from './FileStatusIconErrored';
import { FileStatusIconPaused } from './FileStatusIconPaused';
import { FileStatusIconPreparing } from './FileStatusIconPreparing';
import { FileStatusIconProgressing } from './FileStatusIconProgressing';
import { FileStatusIconStopped } from './FileStatusIconStopped';

export type FileStatusIconProps = {
  size?: FileStatusIconSize;
  status: FileStatus;
};

export const FileStatusIcon = memo(({ size, status }: FileStatusIconProps) => {
  switch (status) {
    case FileStatus.completed:
      return <FileStatusIconCompleted size={size} />;
    case FileStatus.paused:
      return <FileStatusIconPaused size={size} />;
    case FileStatus.stopped:
      return <FileStatusIconStopped size={size} />;
    case FileStatus.errored:
      return <FileStatusIconErrored size={size} />;
    case FileStatus.progressing:
      return <FileStatusIconProgressing size={size} />;
    default:
      return <FileStatusIconPreparing size={size} />;
  }
});

FileStatusIcon.displayName = 'FileStatusIcon';
